import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URI } from 'src/shared/constants';
import { BankAccountDTO } from '@/interfaces/bankAccountDTO.interface';
import { SubmitTransactionQueryReqDTO } from '@/interfaces/submitTransactionQueryReqDTO.interface';
import { ApiResponse } from '@/interfaces/apiresponse.interface';
import { TransactionQueryListItemDTO } from '@/interfaces/transactionQueryListItemDTO.interface';
import { TransactionQueryDetailsDTO } from '@/interfaces/transactionQueryDetailsDTO.interface';

@Injectable({ providedIn: 'root' })
export class TransactionQueryService {
  constructor(private http: HttpClient) {}

  getBankAccounts(technicalUserId: string): Observable<BankAccountDTO[]> {
    const url = API_BASE_URI + `/api/transaction/accounts/${technicalUserId}`;
    return this.http.get<BankAccountDTO[]>(url);
  }

  submitQuery(req: SubmitTransactionQueryReqDTO): Observable<ApiResponse> {
    const url = API_BASE_URI + '/api/transaction/query';
    return this.http.post<ApiResponse>(url, req);
  }

  getQueries(): Observable<TransactionQueryListItemDTO[]> {
    const url = API_BASE_URI + '/api/transaction/query';
    return this.http.get<TransactionQueryListItemDTO[]>(url);
  }

  getQueryDetails(id: number): Observable<TransactionQueryDetailsDTO> {
    const url = API_BASE_URI + `/api/transaction/query/${id}`;
    return this.http.get<TransactionQueryDetailsDTO>(url);
  }

  downloadReport(reportId: number): Observable<Blob> {
    const url = API_BASE_URI + `/api/transaction/report/${reportId}`;
    return this.http.get(url, { responseType: 'blob' });
  }
}
